export default __webpack_public_path__ + "static/media/rail_background.68ce1173.jpg";